import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import createFeatureFlagsPane from 'App/features/featureFlags/components/createPane';
import getConfig from '~/load_config';

import {
  toggle,
  selectAllFeatureFlags,
  FeatureFlagKey,
} from '../featureFlagsSlice';

export default function FeatureFlagsPanel(): JSX.Element | null {
  const dispatch = useDispatch();
  const featureFlags = useSelector(selectAllFeatureFlags);
  const containerRef = useRef<HTMLDivElement>(null);
  const isPaneCreatedRef = useRef(false);
  const [isHidden, toggleIsHidden] = useState(true);

  const {canSeeFeatureFlags} = getConfig();

  useEffect(() => {
    if (
      canSeeFeatureFlags &&
      containerRef.current &&
      !isPaneCreatedRef.current
    ) {
      isPaneCreatedRef.current = true;

      const handleChange = (key: FeatureFlagKey, value: boolean) =>
        dispatch(toggle({key, value}));

      createFeatureFlagsPane(
        containerRef.current,
        {...featureFlags},
        () => toggleIsHidden(prev => !prev),
        handleChange,
      );
    }
  }, [canSeeFeatureFlags, dispatch, featureFlags]);

  return canSeeFeatureFlags ? (
    <div
      ref={containerRef}
      className={twMerge(
        'fixed top-[4px] left-[50%] z-60 w-fit transform overflow-hidden rounded-lg print:hidden',
        isHidden && 'h-[28px] w-[40px] translate-x-[400px]',
      )}
    />
  ) : null;
}
